import React from "react";

// Components
import NoData from "components/NoData";
import Accordion from "components/UiKit/Accordion";

// Navigation
import { Link } from "react-router-dom";

// Interface
interface IChemicalProbs {
  data?: {
    doi?: string;
    title?: string;
    target?: string;
    action?: string;
    px?: number | null;
  } | null;
  inactiveControl?: string[];
}

export const ChemicalProbs: React.FC<IChemicalProbs> = (props) => {
  const { data } = props;

  const px = data?.px ?? null;
  const doi = data?.doi ?? "";
  const title = data?.title ?? "";
  const action = data?.action ?? "";
  const target = data?.target ?? "";

  return (
    <div className="chemical-probs mb5">
      <Accordion
        classNameTitle="mb10"
        isOpen={data !== null}
        title="Chemical probes"
        classNameContent="mb10"
        className="molecule-product__border-accordion"
      >
        {data !== null ? <div className="full-width">
          <div className="chemical-probs__header flex flex-ai-center full-width">
            <div className="chemical-probs__header-col-1 flex flex-ai-center relative">
              <p className="chemical-probs__header-text pl10">Target name</p>
            </div>
            <div className="chemical-probs__header-col-2 flex flex-ai-center chemical-probs__header-text relative">
              <p className="chemical-probs__header-text pl10">Target pX</p>
            </div>
            <div className="chemical-probs__header-col-3 flex flex-ai-center chemical-probs__header-text relative">
              <p className="chemical-probs__header-text pl10">Target action</p>
            </div>
            <div className="chemical-probs__header-col-4 flex flex-ai-center chemical-probs__header-text relative">
              <p className="chemical-probs__header-text pl10">doi</p>
            </div>
          </div>
          <div className="chemical-probs__content flex flex-ai-center full-width">
            <div className="chemical-probs__content-col-1 pt10 relative">
              <p className="chemical-probs__content-text pl10 pr10">{target}</p>
            </div>
            <div className="chemical-probs__content-col-2 pt10 relative">
              <p className="chemical-probs__content-text pl10 pr10">{px}</p>
            </div>
            <div className="chemical-probs__content-col-3 pt10 relative">
              <p className="chemical-probs__content-text pl10 pr10">{action}</p>
            </div>
            <div className="chemical-probs__content-col-4 pt10 relative">
              {!!doi
                ? <Link
                  to={doi}
                  target="_blank"
                  className="chemical-probs__link pl10 pr10"
                >
                  Open link
                </Link>
                : <p className="chemical-probs__content-text pl10 pr10">{title}</p>
              }
            </div>
          </div>
        </div> : <NoData text="No information available" />}
      </Accordion>
    </div>
  );
};

export default ChemicalProbs;